import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-194ecd61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "d-flex justify-content-center pb-10" }
const _hoisted_3 = { class: "d-flex flex-column" }
const _hoisted_4 = { class: "text-start mb-6" }
const _hoisted_5 = {
  class: "fs-4 text-gray-600 fw-semibold",
  style: {"width":"880px"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Declaramos para os devidos fins que o certificado número ")
const _hoisted_7 = { class: "fw-bold text-gray-700" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" é autêntico e foi expedido pela CROWSEC para ")
const _hoisted_11 = { class: "fw-bold text-gray-700" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" no dia ")
const _hoisted_13 = { class: "fw-bold text-gray-700" }
const _hoisted_14 = { class: "certificate-container" }
const _hoisted_15 = { class: "main" }
const _hoisted_16 = { class: "card" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: "https://assets.hackingclub.com/logo_hc_roxo.png",
  alt: ""
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0"} }, "Certificamos que", -1))
const _hoisted_19 = { class: "student-name" }
const _hoisted_20 = { class: "cert-description" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"signs\" data-v-194ecd61><div class=\"sign\" data-v-194ecd61><img src=\"https://assets.hackingclub.com/as-kadu_b.png\" style=\"width:50px;\" alt=\"\" data-v-194ecd61><p class=\"sign-name\" data-v-194ecd61>CARLOS EDUARDO VIEIRA</p><div class=\"line\" data-v-194ecd61></div><p class=\"sign-role\" data-v-194ecd61>Avaliador técnico</p></div><div class=\"sign\" data-v-194ecd61><img src=\"https://assets.hackingclub.com/as-lu_b.png\" style=\"width:80px;\" alt=\"\" data-v-194ecd61><p class=\"sign-name\" data-v-194ecd61>LUCIANE CICHON GOES</p><div class=\"line\" data-v-194ecd61></div><p class=\"sign-role\" data-v-194ecd61>CEO</p></div></div><div class=\"footer-cert\" data-v-194ecd61><div data-v-194ecd61> Valide o certificado em https://app.hackingclub.com/certificate/validate </div><div class=\"logos\" data-v-194ecd61><img style=\"width:40px;\" src=\"https://assets.hackingclub.com/logo_crowsec_b.png\" alt=\"\" data-v-194ecd61><img style=\"width:50px;\" src=\"https://assets.hackingclub.com/logo_hakai_b.png\" alt=\"\" data-v-194ecd61><img style=\"width:60px;\" src=\"https://assets.hackingclub.com/logo_quimera.png\" alt=\"\" data-v-194ecd61></div></div>", 2)
const _hoisted_23 = { style: {"width":"100%","text-align":"center","font-size":"12px","padding-top":"20px","padding-bottom":"20px","background":"#000","color":"white"} }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Código de segurança: ")
const _hoisted_25 = ["href"]


import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  props: {
  certificate: {}
},
  setup(__props) {

const props = __props



const formatDate = (date: string) =>{
  return moment(date).format('DD/MM/YY');
}

const slugToName = (slug: string) =>{
  return slug.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.certificate?.validation_id), 1),
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(__props.certificate?.user_name), 1),
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(formatDate(__props.certificate?.issue_date)) + ".", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("h1", null, _toDisplayString(__props.certificate?.certificate_name), 1),
              _hoisted_18,
              _createElementVNode("h2", _hoisted_19, _toDisplayString(__props.certificate?.user_name), 1),
              _createElementVNode("p", _hoisted_20, _toDisplayString(__props.certificate?.certificate_description), 1),
              _hoisted_21
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("a", {
              href: `https://app.hackingclub.com/certificate/validate?id=${__props.certificate?.validation_id}`,
              target: "_blank",
              style: {"text-decoration":"none","color":"white"}
            }, [
              _createElementVNode("b", null, _toDisplayString(__props.certificate?.validation_id), 1)
            ], 8, _hoisted_25),
            _createTextVNode(" / Emissão realizada em " + _toDisplayString(formatDate(__props.certificate?.issue_date)), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})